import React, { FunctionComponent } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

import { Modal, Text } from '@tradingblock/components';

interface ChangeAccountTypeToEntityConfirmationModalProps {
  onConfirm: () => void;
  onCancel: () => void;
  show: boolean;
};

export const ChangeAccountTypeToEntityConfirmationModal: FunctionComponent<ChangeAccountTypeToEntityConfirmationModalProps> = ({
  onConfirm,
  onCancel,
  show,
}) => {
  return (
    <Modal setShow={() => onCancel()} show={show} backdrop="static" className="service-level-modal">
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>
          <Text id="defaults.changeAccountTypeToEntityConfirmationModal.title" />
        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
        <Text id="defaults.changeAccountTypeToEntityConfirmationModal.body" />
      </BootstrapModal.Body>
      <BootstrapModal.Footer>
        <button type="button" className="btn btn-block btn-primary btn-icon" onClick={onConfirm}>
          <Text id="defaults.btns.confirm" />
        </button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          <Text id="defaults.btns.cancel" />
        </button>
      </BootstrapModal.Footer>
    </Modal>
  );
};
